
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/midi",
      function () {
        return require("private-next-pages/midi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/midi"])
      });
    }
  